import React from 'react'
import { useHistory } from 'react-router-dom'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import Media from 'react-media'

import Search from '_src/components/Search'
import MobileSearch from '_src/components/MobileSearch'
import Menu from '_src/components/Menu'
import { useAppSelector, useAppDispatch } from '_src/store/hooks'

import SelectChain from '_src/components/SelectChain'
import GlobalPayments from '_src/components/GlobalPayments'
import { setPayments } from '_src/store/globalPayments/reducer'

import User from '../User'
import Language from '../Language'

import './index.less'

const InftHeader = ({ className }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useAppDispatch()
  const { paymentsVisible } = useAppSelector((store) => store.globalPayments)
  const handleClose = () => {
    dispatch(setPayments(false))
  }

  const goHome = () => {
    history.push({
      pathname: '/',
    })
  }

  const handleSearch = (data) => {
    data &&
      history.push({
        pathname: '/search',
        state: { global: data },
      })
  }
  return (
    <div className={classNames('inft-header', className)}>
      <Media
        queries={{
          small: '(max-width: 750px)',
          medium: '(min-width: 751px) and (max-width: 1199px)',
          large: '(min-width: 1200px)',
        }}
      >
        {(matches) => (
          <>
            {(matches.small || matches.medium) && (
              <>
                <div className="left-container">
                  <div className="logo" onClick={goHome} />
                  <SelectChain type="mobile" />
                </div>
                <div className="right-container">
                  <MobileSearch />
                  <User type="mobile" />
                  <Menu type="mobile" />
                </div>
              </>
            )}
            {matches.large && (
              <>
                <div className="left-container">
                  <div className="logo" onClick={goHome} />
                  <Language className="header-language" />
                  <Search className="header-search" placeholder={t('home.search_text')} onSearch={handleSearch} />
                </div>

                <div className="right-container">
                  <Menu type="pc" />
                  <SelectChain type="pc" />
                  <User type="pc" />
                </div>
              </>
            )}
          </>
        )}
      </Media>
      {paymentsVisible && <GlobalPayments visible={paymentsVisible} handleClose={handleClose} />}
    </div>
  )
}

export default InftHeader
